import { render, staticRenderFns } from "./StatutoryBasis.vue?vue&type=template&id=74dd6d9e&scoped=true"
import script from "./StatutoryBasis.vue?vue&type=script&lang=js"
export * from "./StatutoryBasis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74dd6d9e",
  null
  
)

export default component.exports